import type { CSSProperties } from "react";
import { cssClass } from "./constant";

export type OddTextOutStylesType = {
  outerDiv: CSSProperties;
  textChoice: CSSProperties;
  textContainer: CSSProperties;
};

export const OddTextOutStyles: OddTextOutStylesType = {
  outerDiv: {
    ...cssClass.outerDiv,
    flexDirection: "row",
    gap: "2%",
  },

  textChoice: {
    ...cssClass.choiceCard,
    borderRadius: "15px",
    ...cssClass.fontFamily,
    ...cssClass.bigFont,
  },

  textContainer: {
    ...cssClass.textContainerBase,
    wordBreak: "break-word",
  },
};
